// extracted by mini-css-extract-plugin
export default {"mapStyle":"styles_mapStyle__G4sUP"};